import React, { useState, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../admincomponents/SideBar';
import TopNavBar from '../admincomponents/TopNavBar';
import Footer from '../admincomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function AdminAddLesson() {
  const { batchid } = useParams();
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [lesson_date, setLessonDate] = useState('');
  const [youtube_link, setYoutubeLink] = useState('');
  const [files, setFiles] = useState([]); // Array of {title, file}
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const addFileField = () => {
    setFiles([...files, { title: '', file: null }]);
  };
  const removeFileField = (index) => {
    const updatedFiles = files.filter((_, i) => i !== index);
    setFiles(updatedFiles);
  };
  const handleFileChange = (index, e) => {
    const updatedFiles = [...files];
    updatedFiles[index].file = e.target.files[0];
    setFiles(updatedFiles);
  };
  const handleFileTitleChange = (index, e) => {
    const updatedFiles = [...files];
    updatedFiles[index].title = e.target.value;
    setFiles(updatedFiles);
  };
  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setError('');
    const formData = new FormData();
    formData.append('batchid', batchid);
    formData.append('title', title);
    formData.append('summary', summary);
    formData.append('lesson_date', lesson_date);
    formData.append('youtube_link', youtube_link);
    formData.append('fileTitles', JSON.stringify(files.map(f => f.title)));
    files.forEach((f) => {
      if (f.file) formData.append('files', f.file);
    });
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('adminSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to add a lesson.');
        setMessageType('error');
        setLoading(false);
        return;
      }
      const response = await axios.post(`${apiUrl}/api/admin/lessons`, formData, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setMessage('Lesson added successfully!');
        setMessageType('success');
        setTitle('');
        setSummary('');
        setLessonDate('');
        setYoutubeLink('');
        setFiles([]);
      } else {
        setMessage(response.data.message || 'Failed to add lesson.');
        setMessageType('error');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Error adding lesson.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  }, [batchid, title, summary, lesson_date, youtube_link, files]); // Dependencies for handleSubmit
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/admin-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <Link to="/admin-view-batches" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    View Batches
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Add Lesson</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card overflow-hidden">
            <div className="card-body p-24">
              <h4 className="mb-16">Add New Lesson</h4>
              {message && (
                <div className={`alert alert-${messageType} mb-16`}>
                  {message}
                </div>
              )}
              {error && (
                <div className="alert alert-danger mb-16">
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit} className="mb-24">
                <div className="mb-3">
                  <label htmlFor="title" className="form-label">Title</label>
                  <input
                    type="text"
                    className="form-control"
                    id="title"
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="summary" className="form-label">Summary</label>
                  <textarea
                    className="form-control"
                    id="summary"
                    value={summary}
                    onChange={(e) => setSummary(e.target.value)}
                  ></textarea>
                </div>
                <div className="mb-3">
                  <label htmlFor="lesson_date" className="form-label">Lesson Date</label>
                  <input
                    type="date"
                    className="form-control"
                    id="lesson_date"
                    value={lesson_date}
                    onChange={(e) => setLessonDate(e.target.value)}
                    required
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="youtube_link" className="form-label">YouTube Link</label>
                  <input
                    type="url"
                    className="form-control"
                    id="youtube_link"
                    value={youtube_link}
                    onChange={(e) => setYoutubeLink(e.target.value)}
                  />
                </div>
                <div className="mb-4">
                  <label className="form-label">Files</label>
                  <div className="d-flex align-items-center mb-3">
                    <button type="button" className="btn btn-dark me-3" onClick={addFileField}>
                      Add File
                    </button>
                  </div>
                  {files.map((file, index) => (
                    <div key={index} className="card mb-3 p-3">
                      <div className="row g-3">
                        <div className="col-md-5">
                          <input
                            type="text"
                            className="form-control"
                            placeholder="File Title"
                            value={file.title}
                            onChange={(e) => handleFileTitleChange(index, e)}
                            required
                          />
                        </div>
                        <div className="col-md-5">
                          <input
                            type="file"
                            className="form-control"
                            onChange={(e) => handleFileChange(index, e)}
                            required
                          />
                        </div>
                        <div className="col-md-2">
                          <button type="button" className="btn btn-outline-danger w-100" onClick={() => removeFileField(index)}>
                            Remove
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <button type="submit" className="btn btn-primary mt-4" disabled={loading}>
                  {loading ? 'Adding...' : 'Add Lesson'}
                </button>
              </form>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default AdminAddLesson;